import React, { FC } from 'react';

const ContactStructuredData: FC = () => {
    const postalAddressStructuredData = {
        '@type': 'PostalAddress',
        '@id': 'https://www.skapiec.pl/#/schema/Address/Organization/1',
        'streetAddress': 'ul. Domaniewska 49',
        'addressLocality': 'Mazowieckie',
        'postalCode': '02-672',
        'addressRegion': 'Warszawa',
        'addressCountry': 'PL'
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(postalAddressStructuredData) }}
        />
    );
};

export default ContactStructuredData;
